import { 
  CREATE_ORGANIZATION_FAIL,
  CREATE_ORGANIZATION_REQUEST,
  CREATE_ORGANIZATION_RESET,
  CREATE_ORGANIZATION_SUCCESS,
  GET_ORGANIZATION_LIST_FAIL, 
  GET_ORGANIZATION_LIST_REQUEST, 
  GET_ORGANIZATION_LIST_SUCCESS, 
   
  GET_SUPPORT_REQUEST_LIST_FAIL,
  GET_SUPPORT_REQUEST_LIST_REQUEST,
  GET_SUPPORT_REQUEST_LIST_SUCCESS, 

  UPDATE_SUPPORT_REQUEST_STATUS_FAIL,
  UPDATE_SUPPORT_REQUEST_STATUS_REQUEST,
  UPDATE_SUPPORT_REQUEST_STATUS_SUCCESS,

  GET_NEWS_LETTER_LIST_FAIL,
    GET_NEWS_LETTER_LIST_SUCCESS,
    GET_NEWS_LETTER_LIST_REQUEST,

    GET_MEETING_SLOT_FAIL,
    GET_MEETING_SLOT_SUCCESS,
    GET_MEETING_SLOT_REQUEST,
    CREATE_MEETING_SLOT_FAIL,
    CREATE_MEETING_SLOT_SUCCESS,
    CREATE_MEETING_SLOT_REQUEST,

    GET_SALE_INQUIRY_FAIL,
    GET_SALE_INQUIRY_SUCCESS,
    GET_SALE_INQUIRY_REQUEST, 

    UPDATE_DEMO_MEETING_STATUS_FAIL,
    UPDATE_DEMO_MEETING_STATUS_REQUEST,
    UPDATE_DEMO_MEETING_STATUS_SUCCESS,

    GET_USERS_LIST_FAIL,
    GET_USERS_LIST_SUCCESS,
    GET_USERS_LIST_REQUEST
} from "../../Constants/OrganizationConstant"
import {
  GET_ORGANIZATION_DETAILS_FAIL,
  GET_ORGANIZATION_DETAILS_REQUEST,
  GET_ORGANIZATION_DETAILS_SUCCESS,
  GET_ORG_PAYMENT_DETAILS_FAIL,
  GET_ORG_PAYMENT_DETAILS_REQUEST,
  GET_ORG_PAYMENT_DETAILS_SUCCESS,
  ACTIVATE_EVAL_PROMO_FAIL,
  ACTIVATE_EVAL_PROMO_REQUEST,
  ACTIVATE_EVAL_PROMO_SUCCESS,
  DEACTIVATE_ORGANIZATION_FAIL,
  DEACTIVATE_ORGANIZATION_REQUEST,
  DEACTIVATE_ORGANIZATION_SUCCESS,
  DEACTIVATE_BREW_USER_FAIL,
  DEACTIVATE_BREW_USER_REQUEST,
  DEACTIVATE_BREW_USER_SUCCESS,
  GET_ORG_MEMBERS_LIST_FAIL,
  GET_ORG_MEMBERS_LIST_REQUEST,
  GET_ORG_MEMBERS_LIST_SUCCESS,
  ASSIGN_ACCOUNT_MANAGER_FAIL,
  ASSIGN_ACCOUNT_MANAGER_REQUEST,
  ASSIGN_ACCOUNT_MANAGER_SUCCESS,
  ASSIGN_ACCOUNT_MANAGER_RESET,
  REMOVE_ACCOUNT_MANAGER_FAIL,
  REMOVE_ACCOUNT_MANAGER_REQUEST,
  REMOVE_ACCOUNT_MANAGER_SUCCESS,
  GET_ORG_PRICING_REQUEST,
  GET_ORG_PRICING_SUCCESS,
  GET_ORG_PRICING_FAIL,
  GET_ORG_PRICING_HISTORY_REQUEST,
  GET_ORG_PRICING_HISTORY_SUCCESS,
  GET_ORG_PRICING_HISTORY_FAIL,
  ORG_PRICING_MUTATION_REQUEST,
  ORG_PRICING_MUTATION_SUCCESS,
  ORG_PRICING_MUTATION_FAIL,
  ORG_PRICING_MUTATION_RESET,
} from "../../Constants/OrganizationConstant";


const initialStateAdmin = {
    loading_change_password: false,
    status_change_password: false,
    user_login_data: null,
    login_loading: false,
    login_status: null,
    logout_status: false,
    error_change_password: null,
};


const initialStateDefault = {
    status: false,
    data: null,
    loading: true,
    error: null,
}

const initialStateMutation = {
    status: false,
    data: null,
    loading: false,
    error: null,
}


export const OrganizationListData = (state = initialStateDefault, action: any) => {
    try {
      
        if (action.type === GET_ORGANIZATION_LIST_REQUEST) {
            return {
              ...state,
              loading: true,
            };
          }
      
          if (action.type === GET_ORGANIZATION_LIST_SUCCESS) {
            return {
              ...state,
              status: true,
              loading: false,
              data: action.data,
            };
          }
          if (action.type === GET_ORGANIZATION_LIST_FAIL) {
            return {
              ...state,
              status: false,
              loading: false,
              data: action.data,
            };
          }
    } catch (error) {

    }
    return state;
}

export const UsersListData = (state = initialStateDefault, action: any) => {
  try {
    
      if (action.type === GET_USERS_LIST_REQUEST) {
          return {
            ...state,
            loading: true,
          };
        }
    
        if (action.type === GET_USERS_LIST_SUCCESS) {
          return {
            ...state,
            status: true,
            loading: false,
            data: action.data,
          };
        }
        if (action.type === GET_USERS_LIST_FAIL) {
          return {
            ...state,
            status: false,
            loading: false,
            data: action.data,
          };
        }
  } catch (error) {

  }
  return state;
}




export const SupportRequestListData = (state = initialStateDefault, action: any) => {
  try {
 
      if (action.type === GET_SUPPORT_REQUEST_LIST_REQUEST) {
          return {
            ...state,
            loading: true,
          };
        }
    
        if (action.type === GET_SUPPORT_REQUEST_LIST_SUCCESS) {
          return {
            ...state,
            status: true,
            loading: false,
            data: action.data,
          };
        }
        if (action.type === GET_SUPPORT_REQUEST_LIST_FAIL) {
          return {
            ...state,
            status: false,
            loading: false,
            data: action.data,
          };
        }
  } catch (error) {

  }
  return state;
}


export const UpdateSupportRequestStatus = (state = initialStateDefault, action: any) => {
  try {
  
      if (action.type === UPDATE_SUPPORT_REQUEST_STATUS_REQUEST) {
          return {
            ...state,
            loading: true,
          };
        }
    
        if (action.type === UPDATE_SUPPORT_REQUEST_STATUS_SUCCESS) {
          return {
            ...state,
            status: true,
            loading: false,
            data: action.data,
          };
        }
        if (action.type === UPDATE_SUPPORT_REQUEST_STATUS_FAIL) {
          return {
            ...state,
            status: false,
            loading: false,
            data: action.data,
          };
        }
  } catch (error) {

  }
  return state;
}



export const NewsLettertListData = (state = initialStateDefault, action: any) => {
  try {
 
      if (action.type === GET_NEWS_LETTER_LIST_REQUEST) {
          return {
            ...state,
            loading: true,
          };
        }
    
        if (action.type === GET_NEWS_LETTER_LIST_SUCCESS) {
          return {
            ...state,
            status: true,
            loading: false,
            data: action.data,
          };
        }
        if (action.type === GET_NEWS_LETTER_LIST_FAIL) {
          return {
            ...state,
            status: false,
            loading: false,
            data: action.data,
          };
        }
  } catch (error) {

  }
  return state;
}


export const MeetingSlotData = (state = initialStateDefault, action: any) => {
  try {
 
      if (action.type === GET_MEETING_SLOT_REQUEST) {
          return {
            ...state,
            loading: true,
          };
        }
    
        if (action.type === GET_MEETING_SLOT_SUCCESS) {
          return {
            ...state,
            status: true,
            loading: false,
            data: action.data,
          };
        }
        if (action.type === GET_MEETING_SLOT_FAIL) {
          return {
            ...state,
            status: false,
            loading: false,
            data: action.data,
          };
        }
  } catch (error) {

  }
  return state;
}

export const CreateMeetingSlotData = (state = initialStateDefault, action: any) => {
  try {
      if (action.type === CREATE_MEETING_SLOT_REQUEST) {
          return {
            ...state,
            loading: true,
          };
        }
    
        if (action.type === CREATE_MEETING_SLOT_SUCCESS) {
          return {
            ...state,
            status: true,
            loading: false,
            data: action.data,
          };
        }
        if (action.type === CREATE_MEETING_SLOT_FAIL) {
          return {
            ...state,
            status: false,
            loading: false,
            data: action.data,
          };
        }
  } catch (error) {}
  return state;
}

export const SaleInquiriesListData = (state = initialStateDefault, action: any) => {
  try {
 
      if (action.type === GET_SALE_INQUIRY_REQUEST) {
          return {
            ...state,
            loading: true,
          };
        }
    
        if (action.type === GET_SALE_INQUIRY_SUCCESS) {
          return {
            ...state,
            status: true,
            loading: false,
            data: action.data,
          };
        }
        if (action.type === GET_SALE_INQUIRY_FAIL) {
          return {
            ...state,
            status: false,
            loading: false,
            data: action.data,
          };
        }
  } catch (error) {

  }
  return state;
}


export const UpdateDemoStatusData = (state = initialStateDefault, action: any) => {
  try {
 
      if (action.type === UPDATE_DEMO_MEETING_STATUS_REQUEST) {
          return {
            ...state,
            loading: true,
          };
        }
    
        if (action.type === UPDATE_DEMO_MEETING_STATUS_SUCCESS) {
          return {
            ...state,
            status: true,
            loading: false,
            data: action.data,
          };
        }
        if (action.type === UPDATE_DEMO_MEETING_STATUS_FAIL) {
          return {
            ...state,
            status: false,
            loading: false,
            data: action.data,
          };
        }
  } catch (error) {

  }
  return state;
}

export const OrganizationDetailsData = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_ORGANIZATION_DETAILS_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_ORGANIZATION_DETAILS_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_ORGANIZATION_DETAILS_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const OrganizationPaymentDetailsData = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_ORG_PAYMENT_DETAILS_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }
    if (action.type === GET_ORG_PAYMENT_DETAILS_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_ORG_PAYMENT_DETAILS_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const ActivateEvalPromoData = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === ACTIVATE_EVAL_PROMO_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }
    if (action.type === ACTIVATE_EVAL_PROMO_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === ACTIVATE_EVAL_PROMO_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const DeactivateOrganizationData = (
  state = initialStateMutation,
  action: any
) => {
  try {
    if (action.type === DEACTIVATE_ORGANIZATION_REQUEST) {
      return {
        ...state,
        loading: true,
        status: false,
        error: null,
      };
    }
    if (action.type === DEACTIVATE_ORGANIZATION_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };
    }
    if (action.type === DEACTIVATE_ORGANIZATION_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
        error: action?.error ?? null,
      };
    }
  } catch (error) {}
  return state;
};

export const DeactivateBrewUserData = (
  state = initialStateMutation,
  action: any
) => {
  try {
    if (action.type === DEACTIVATE_BREW_USER_REQUEST) {
      return {
        ...state,
        loading: true,
        status: false,
        error: null,
      };
    }
    if (action.type === DEACTIVATE_BREW_USER_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };
    }
    if (action.type === DEACTIVATE_BREW_USER_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
        error: action?.error ?? null,
      };
    }
  } catch (error) {}
  return state;
};

export const OrgMembersListData = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_ORG_MEMBERS_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    if (action.type === GET_ORG_MEMBERS_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };
    }
    if (action.type === GET_ORG_MEMBERS_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: null,
        error: action?.error ?? "Failed to load members.",
      };
    }
  } catch (error) {}
  return state;
};

export const AssignAccountManagerData = (
  state = initialStateMutation,
  action: any
) => {
  try {
    if (action.type === ASSIGN_ACCOUNT_MANAGER_REQUEST) {
      return {
        ...state,
        loading: true,
        status: false,
        error: null,
      };
    }
    if (action.type === ASSIGN_ACCOUNT_MANAGER_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };
    }
    if (action.type === ASSIGN_ACCOUNT_MANAGER_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
        error: action?.error ?? null,
      };
    }
    if (action.type === ASSIGN_ACCOUNT_MANAGER_RESET) {
      return initialStateMutation;
    }
  } catch (error) {}
  return state;
};

export const RemoveAccountManagerData = (
  state = initialStateMutation,
  action: any
) => {
  try {
    if (action.type === REMOVE_ACCOUNT_MANAGER_REQUEST) {
      return {
        ...state,
        loading: true,
        status: false,
        error: null,
      };
    }
    if (action.type === REMOVE_ACCOUNT_MANAGER_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };
    }
    if (action.type === REMOVE_ACCOUNT_MANAGER_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
        error: action?.error ?? null,
      };
    }
  } catch (error) {}
  return state;
};


export const OrgPricingData = (
  state = {
    status: false,
    data: [],
    loading: true,
    error: null,
  },
  action: any
) => {
  switch (action.type) {
    case GET_ORG_PRICING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ORG_PRICING_SUCCESS:
      return {
        ...state,
        status: true,
        data: action.data,
        loading: false,
        error: null,
      };

    case GET_ORG_PRICING_FAIL:
      return {
        ...state,
        status: false,
        data: [],
        loading: false,
        error: action.error || null,
      };

    default:
      return state;
  }
};

export const OrgPricingHistoryData = (
  state = {
    status: false,
    data: [],
    loading: false,
    error: null,
  },
  action: any
) => {
  switch (action.type) {
    case GET_ORG_PRICING_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ORG_PRICING_HISTORY_SUCCESS:
      return {
        ...state,
        status: true,
        data: action.data,
        loading: false,
        error: null,
      };

    case GET_ORG_PRICING_HISTORY_FAIL:
      return {
        ...state,
        status: false,
        data: [],
        loading: false,
        error: action.error || null,
      };

    default:
      return state;
  }
};

export const OrgPricingMutationData = (
  state = {
    status: false,
    data: null,
    loading: false,
    error: null,
  },
  action: any
) => {
  switch (action.type) {
    case ORG_PRICING_MUTATION_REQUEST:
      return {
        ...state,
        status: false,
        loading: true,
        error: null,
      };

    case ORG_PRICING_MUTATION_SUCCESS:
      return {
        ...state,
        status: true,
        data: action.data,
        loading: false,
        error: null,
      };

    case ORG_PRICING_MUTATION_FAIL:
      return {
        ...state,
        status: false,
        loading: false,
        error: action.error || null,
      };

    case ORG_PRICING_MUTATION_RESET:
      return {
        status: false,
        data: null,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};




export const CreateOrganizationData = (
  state = initialStateMutation,
  action: any
) => {
  try {
    if (action.type === CREATE_ORGANIZATION_REQUEST) {
      return { ...state, loading: true, status: false, error: null };
    }
    if (action.type === CREATE_ORGANIZATION_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };
    }
    if (action.type === CREATE_ORGANIZATION_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
        error: action?.error ?? null,
      };
    }
    if (action.type === CREATE_ORGANIZATION_RESET) {
      return initialStateMutation;
    }
  } catch (error) {}
  return state;
};
